<template lang="html">
  <div class="mpv-tooltip">
    <div :class="noHover ? '' : 'mpv-tooltip-content'">
      <slot></slot>
    </div>
    <div @click="handleClick"
         :class="[
           'mpv-tooltip-text',
           short && position !== 'left' ? 'mpv-tooltip-text-short' : '',
           position === 'left' ? 'mpv-tooltip-text-left' : '',
           position === 'right' ? 'mpv-tooltip-text-right' : '',
           noClose ? 'mpv-tooltip-text-noClose' : '',
           active ? 'mpv-tooltip-active' : '',
           gray ? 'mpv-tooltip-text-gray' : '',
           noTip ? 'mpv-tooltip-text-noTip' : ''
         ]">
      <span>{{ text }}</span>
      <font-awesome-icon class="mpv-tooltip-close-icon"
                         v-if="!noClose"
                         :icon="[ 'fas', 'times' ]"/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Tooltip text'
    },
    active: Boolean,
    noHover: Boolean,
    noClose: Boolean,
    position: {
      type: String,
      default: "center"
    },
    gray: Boolean,
    noTip: Boolean
  },

  computed: {
    short () { return this.text.length < 20 }
  },

  methods: {
    handleClick () {
      if (!this.noClose)
        this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';
  @import '../../scss/breakpoints';

  .mpv-tooltip {
    position: relative;
    font-size: 90%;
    z-index: unset;

    &-text {
      display: none;
      font-weight: bold;
      opacity: 0;
      position: absolute;
      text-align: center;
      bottom: 2.25rem;
      left: -140px;
      width: max-content;
      max-width: 320px;
      padding: 0.5rem 0 0.5rem 0.5rem;
      background-color: $blue;
      color: $white;
      line-height: 1.35rem;
      border-radius: 3px;
      //box-shadow: 1px 2px 2px $gray-200;
      transition: ease 0.3s;
      z-index: 1;

      &:before {
        position: absolute;
        bottom: -8px;
        left: 148px;
        border-left: -3px solid transparent;
        border-right: 8px solid transparent;
        border-top: 9px solid $blue;
        content: "";
      }

      &-short {
        left: -82px;

        &:before {
          left: 100px;
        }
      }

      &-left {
        left: unset;
        right: -50%;

        &:before {
          left: unset;
          right: 5%;
        }
      }

      &-right {
        left: 0;
        right: unset;

        &:before {
          left: 50px;
          right: unset;
        }
      }

      &-gray {
        background-color: $dark;

        &:before {
          border-top: 9px solid $dark !important;
        }
      }

      &-noTip {
        &:before {
          border: none;
        }
      }

      &-noClose {
        padding: 0.25rem 0.5rem;
      }
    }

    &-content {
      &:hover ~ .mpv-tooltip-text {
        opacity: 1;
        display: flex;
      }
    }

    &-active {
      opacity: 1;
      display: flex;
    }

    &-close-icon {
      margin: 0 4px;
      padding: 0 4px;
      cursor: pointer;
      color: $white;
      height: 1.3rem !important;
      width: 1.3rem !important;
      border-radius: 3px;
      background-color: transparentize($gray-200, 0.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/Tooltip.vue